import Typography from '@mui/material/Typography';

function SubscriptionPageHeader(props) {
  return (
    <div className="flex w-full container font-inter">
      <div className="flex flex-col sm:flex-row flex-auto sm:items-center min-w-0 p-24 md:p-32 pb-0 md:pb-0">
        <div className="flex flex-col flex-auto">
          <Typography className="mt-32 text-center text-4xl font-bold tracking-tight leading-8">
            Upgrade your plan
          </Typography>
          <Typography className="mt-8 font-medium text-xl text-gray-800 tracking-tight text-center">
            Flexible pricing for small businesses to large enterprises. No contract, free cancellation.
          </Typography>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionPageHeader;
